import {combineReducers, Reducer} from '@reduxjs/toolkit'

import {routerReducer} from '@web/slices/router'

import {SubscriptionRootState as RootState} from '../../interfaces'
import account from '../../slices/account'
import agreement from '../../slices/agreement'
import banner from '../../slices/banner'
import card from '../../slices/card'
import cashReceipt from '../../slices/cashReceipt'
import chargePoint from '../../slices/chargePoint'
import common from '../../slices/common'
import deliveryGroup from '../../slices/deliveryGroup'
import deliveryInfo from '../../slices/deliveryInfo'
import deliveryManager from '../../slices/deliveryManager'
import fds from '../../slices/fds'
import merchants from '../../slices/merchants'
import modal from '../../slices/modal'
import orderSheetCoupon from '../../slices/orderSheetCoupon'
import orderSheetProducts from '../../slices/orderSheetProducts'
import orderTotal from '../../slices/orderTotal'
import personalCustomsClearance from '../../slices/personalCustomsClearance'
import pointPayment from '../../slices/pointPayment'
import priorityPaymentMethod from '../../slices/priorityPaymentMethod'
import purchaser from '../../slices/purchaser'
import reward from '../../slices/reward'
import rewardPoint from '../../slices/rewardPoint'
import shoppingSubscription from '../../slices/shoppingSubscription'
import subscribe from '../../slices/subscribe'

const createRootReducer = (): Reducer<RootState> =>
    combineReducers({
        account,
        agreement,
        banner,
        card,
        cashReceipt,
        chargePoint,
        common,
        deliveryGroup,
        deliveryInfo,
        deliveryManager,
        fds,
        merchants,
        modal,
        orderSheetCoupon,
        orderSheetProducts,
        orderTotal,
        personalCustomsClearance,
        pointPayment,
        priorityPaymentMethod,
        purchaser,
        // receiverInfo
        reward,
        rewardPoint,
        router: routerReducer,
        shoppingSubscription,
        subscribe,
    })

export default createRootReducer
